/*
ashraf 10/16/2022  2700520533 added code comments in search, add role management.
akhilaavvaru 10/27/2022 2700520533 role management UX changes
Sohel 12/12/2022 2700524332 Implemented Copy Functionality
Akhila 06/05/2023 2700524332 unsaved changes bug fixed/implemented
*/

import React, {useEffect, useRef} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SearchRoleManagement from './SearchRoleManagement/SearchRoleManagement';
import AddRole from './AddRole/AddRole';
import useUnsavedChangesWarning from '../../util/CustomHooks';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

// role management sub tabs search role, add role component render (2700520533)
export default function RoleManagementTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const showAlertRef = useRef(false);
  const {onDirty, onPristine} = useUnsavedChangesWarning();
  const [roleId, setRoleId] = React.useState(null);
  const [moduleNames, setModuleNames] = React.useState([]);
  const [isCopy, setIsCopy] = React.useState(false);
  // resetting role id to null to clear previous role prepopulated data in add role (2700520533)
  useEffect(() => {
    if (value === 0) {
      setRoleId(null);
    }
  }, [value]);

  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };

  return (
    <div className={classes.root}>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchRoleManagement
            setValue={setValue}
            setRoleId={setRoleId}
            setModuleNames={setModuleNames}
            isCopy={isCopy}
            setIsCopy={setIsCopy}
          />
        ) : null}
      </div>
      <div className={classes.subContent}>
        {value === 1 ? (
          <AddRole
            setValue={setValue}
            roleId={roleId}
            setRoleId={setRoleId}
            moduleNames={moduleNames}
            isCopy={isCopy}
            {...alertProps}
          />
        ) : null}
      </div>
    </div>
  );
}
